export const PortalPassEndpoints = {
  post: `portal-protection`
}
